export interface IPrepareFeatureArg {
  bathrooms: string | number | null;
  halfBathrooms: string | number | null;
  bedrooms: string | number | null;
  floorLevel: string | number | null;
  floorsTotal: string | number | null;
  sqmLand: string | number | null;
  sqmConstruction: string | number | null;
  pumps: string | number | null;
  parkingSpots: string | number | null;
}
export const prepareFeature = (props: IPrepareFeatureArg) => {
  return { ...props };
};
